import Resources from "../../shared/actions/resourcesActions";

class UnitTypesResource extends Resources {
  constructor(dispatch) {
    super(dispatch, "unit_types", `/api/v1/unit_types`);
  }
}

export default UnitTypesResource;
